import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ISubscription } from 'rxjs/Subscription';
import { SearchSectionLabelPipe } from '../../../pipes/search-section-label.pipe';

@Component({
    selector: 'app-section-search',
    templateUrl: './section-search.component.html',
    styleUrls: ['./section-search.component.css'],
    providers: [
        SearchSectionLabelPipe
    ]
})
export class SectionSearchComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    displaysFull = false;

    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.subscriptions.push(
            this.activeRoute.url.subscribe(
                url => {
                    const childUrl = this.router.routerState.snapshot.url;
                    this.displaysFull = (childUrl.indexOf('search/edition') !== -1);
                },
                err => console.error(err)
            )
        );
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/sections/section-search/section-search.component.ts